<template>
  <div class="week_star">
    <ul v-if="rainVisible" class="spark-section" id="spark-section">
      <template v-for="(item, index) in rainParams">
        <li
          class="move_1"
          :style="{
            left: item.left,
            animationDuration: item.durTime,
            webkitAnimationDuration: item.durTime,
          }"
          :data-index="index"
          :key="index"
        >
          <div class="move-item" :class="`spark-${(index + 1) % 5}`"></div>
        </li>
      </template>
      <img class="weekstar_img" src="../images/weekstar.png" alt="" />
      <div class="close">
        <i class="el-icon-circle-close" @click="close"></i>
      </div>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'weekstar',
  data() {
    return {
      rainVisible: false,
      rainParams: [], // 所有星石
      timer: null,
      duration: '',
    }
  },
  created() {
    this.settingData = {
      continueTime: 1, // 下雨时长
      dropWealthNum: 30, // 在对应的时长里面,应该下落多少个红包
    }
    this.duration = this.settingData.continueTime * 1000
    this.continueTime = this.settingData.continueTime
  },
  methods: {
    startRedPacket() {
      const win =
        document.documentElement.clientWidth || document.body.clientWidth
      var plusOrMinus = Math.random() < 0.5 ? -1 : 1
      const left =
        parseInt(Math.random() * (win - 50) + 0) +
        Math.random() * 10 * plusOrMinus
      const rotate = parseInt(Math.random() * (45 - -45) - 45) + 'deg' // 旋转角度
      const durTime = Math.random() * (2.5 - 1.2 + 1) + 1.2 + 's' // 时间
      // 1.2和1.2这个数值保持一样
      this.rainParams.push({
        left: left + 'px',
        transforms: 'rotate(' + rotate + ')',
        durTime: durTime,
        isHide: false,
      })
      setTimeout(() => {
        // 多少时间结束
        clearTimeout(this.timer)
        this.timer = null
        return false
      }, this.duration)
      this.timer = setTimeout(() => {
        this.startRedPacket()
      }, Math.round(this.duration / this.settingData.dropWealthNum))
    },

    // 点击弹框
    show() {
      this.rainVisible = true
      this.dialogVisible = true
      this.normalVisible = true
      this.startRedPacket()
    },
    close() {
      this.rainVisible = false
      this.dialogVisible = false
      this.normalVisible = false

      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.week_star {
  .close {
    position: absolute;
    bottom: 23vh;
    right: 49%;
    font-size: 54px;
    & > i {
      z-index: 9999;
      color: #f89c03;
      cursor: pointer;
    }
  }
  .spark-section {
    display: block;
    overflow: hidden;
    position: absolute;
    left: 0vh;
    top: 0vh;
    height: 100vh;
    width: 100%;
    // background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    text-align: center;
    li {
      position: absolute;
      animation: all 3s linear;
      top: -100px;
      z-index: 0;
      &.move_1 {
        animation: aim_move 4s linear 1 forwards;
        position: relative;
      }
      .move-item {
        animation: cicle 2s infinite linear;
        position: absolute;
        left: 0px;
        top: 0px;
      }
      @keyframes cicle {
        0% {
          transform: rotate(0deg);
          left: 10px;
        }
        10% {
          transform: rotate(30deg);
          left: 0px;
        }
        20% {
          transform: rotate(60deg);
          left: -10px;
        }
        30% {
          transform: rotate(90deg);
          left: 0px;
        }
        40% {
          transform: rotate(120deg);
          left: 10px;
        }
        50% {
          transform: rotate(150deg);
          left: 0px;
        }
        60% {
          transform: rotate(180deg);
          left: -10px;
        }
        70% {
          transform: rotate(210deg);
          left: 0px;
        }
        80% {
          transform: rotate(240deg);
          left: 10px;
        }
        90% {
          transform: rotate(240deg);
          left: 0px;
        }
        100% {
          transform: rotate(270deg);
          left: -10px;
        }
      }
    }
    a {
      display: block;
    }
  }
  @keyframes scaleDraw {
    0% {
      transform: scale(1); /*开始为原始大小*/
    }
    // 25% {
    //   transform: scale(1.1); /*放大1.1倍*/
    // }
    50% {
      transform: scale(1.1);
    }
    // 75% {
    //   transform: scale(1.1);
    // }
  }

  .weekstar_img {
    object-fit: fill;
    width: 75%;
    margin-top: 5vh;
    -webkit-animation-name: scaleDraw; /*关键帧名称*/
    -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
    -webkit-animation-iteration-count: 1; /*动画播放的次数*/
    -webkit-animation-duration: 3s; /*动画所花费的时间*/
  }
  @keyframes aim_move {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(120vh);
    }
  }
  .spark-1 {
    width: 24px;
    height: 24px;
    background: #ffe034;
  }
  .spark-2 {
    width: 24px;
    height: 24px;
    background: #2893ff;
  }
  .spark-3 {
    width: 24px;
    height: 24px;
    background: #15e3d1;
  }
  .spark-4 {
    width: 24px;
    height: 24px;
    background: #8a78fd;
  }
  .spark-0 {
    width: 24px;
    height: 24px;
    background: #ffa933;
  }
}
</style>
